<div class="o360-confirm-dialog">
  <h1 mat-dialog-title class="o360-confirm-dialog__title">{{ data.title }}</h1>

  <div mat-dialog-content class="o360-confirm-dialog__content">
    <p class="o360-confirm-dialog__description">
      {{ data.description }}@if (data.item) {
      <span class="o360-confirm-dialog__item"> "{{ data.item }}"</span>
    }
  </p>
</div>

<div mat-dialog-actions class="o360-confirm-dialog__actions">
  @if (data.hasCancelButton) {
    <button
      mat-stroked-button
      type="button"
      class="o360-confirm-dialog__button o360-confirm-dialog__button--secondary"
      [mat-dialog-close]="false">
      Cancelar
    </button>
  }

  @if (data.hasNoButton) {
    <button
      mat-stroked-button
      type="button"
      class="o360-confirm-dialog__button o360-confirm-dialog__button--secondary"
      [mat-dialog-close]="false">
      Não
    </button>
  }

  @if (data.hasOkButton) {
    <button
      mat-flat-button
      type="button"
      class="o360-confirm-dialog__button o360-confirm-dialog__button--primary"
      [mat-dialog-close]="true"
      cdkFocusInitial>
      Ok
    </button>
  }

  @if (data.hasYesButton) {
    <button
      mat-flat-button
      type="button"
      class="o360-confirm-dialog__button o360-confirm-dialog__button--primary"
      [mat-dialog-close]="true"
      cdkFocusInitial>
      Sim
    </button>
  }
</div>
</div>
